import { HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
   providedIn: 'root',
})
export class SharedService {

   constructor(public http: HttpClient) {}

   setLocalstorage = (name: string, items: any) => localStorage.setItem(name, JSON.stringify(items));
   getLocalstorage = (name: string) => JSON.parse(localStorage.getItem(name));
   deleteLocalstorage = (name: string) => localStorage.removeItem(name);
}
